import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Circles } from "react-loader-spinner";

import KhaltiCheckout from "khalti-checkout-web";

const Payment = () => {
  const [modal, setModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [paymentSuccess, setPaymentSuccess] = React.useState(false);

  const [emailConfirmed, setEmailConfirmed] = React.useState(false);
  const [confirmationEmail, setConfirmationEmail] = React.useState("");

  const [emailConfirmationResponse, setEmailConfirmationResponse] =
    React.useState();

  const confirmEmail = async (e) => {
    e.preventDefault();

    try {
      setEmailConfirmed(false);
      let response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/api/book/confirmEmail`,
        {
          confirmationEmail,
        }
      );

      setEmailConfirmationResponse(response.data);
      setEmailConfirmed(true);
    } catch (e) {
      setEmailConfirmationResponse(e.response.data);

      setEmailConfirmed(true);
    }
  };

  /**
   * KHALTI SETUP
   */

  let config = {
    // replace this key with yours
    publicKey: `${process.env.REACT_APP_KHALTI_PUBLIC_KEY}`,
    productIdentity: "33588410008749332145200",
    productName: "Decorum Technology Training Fee",
    productUrl: "https://www.decorumtechnology.com",
    eventHandler: {
      async onSuccess(payload) {
        // hit merchant api for initiating verfication
        let data = {
          data: {
            token: payload.token,
            amount: payload.amount,
          },
          bookingEmail: confirmationEmail,
        };
        try {
          setLoading(true);
          const response = await axios.post(
            `${process.env.REACT_APP_API_KEY}/api/book/payment`,
            data
          );
          if (response.data.status === "success") {
            setPaymentSuccess(true);
          } else if (response.data.status === "failure") {
            setPaymentSuccess(false);
          }
        } catch (e) {
          setLoading(false);
          setModal(false);
          console.log(e);
        }
        setLoading(false);
        setModal(true);
      },
      // onError handler is optional
      onError(error) {
        // handle errors

        console.log(error);
      },
      onClose() {
        console.log("widget is closing");
      },
    },
    paymentPreference: [
      "KHALTI",
      "EBANKING",
      "MOBILE_BANKING",
      "CONNECT_IPS",
      "SCT",
    ],
  };

  let checkout = new KhaltiCheckout(config);

  const payWithKhalti = () => {
    checkout.show({ amount: 4999 * 100 });
  };

  const decide = () => {
    if (emailConfirmed) {
      if (emailConfirmationResponse.status === "success") {
        return (
          <div className="vertical-center">
            <p>HELLO! {emailConfirmationResponse.data.fullName}</p>
            <button
              onClick={payWithKhalti}
              type="button"
              className="submit-button"
            >
              Click here to pay
            </button>
          </div>
        );
      } else if (emailConfirmationResponse.status === "failure") {
        return (
          <div className="vertical-center">
            <p>{emailConfirmationResponse.data}</p>
            <Link to="/"> Click here to book! </Link>
          </div>
        );
      } else {
        return;
      }
    }
  };

  const modalMessage = () => {
    return (
      <div className="modal__container">
        <div className="modal__wrapper">
          <h5> {paymentSuccess ? "Payment Successful" : "Payment Failure"}</h5>
          <p style={{ fontSize: "12px", fontWeight: "400" }}>
            {paymentSuccess
              ? "You have succesfully fulfilled your payment. We will contact you soon"
              : ""}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      <div className="wrapper">
        <p className="header">PAY YOUR TRAINING FEE</p>
        <div className="form__container">
          {modal && modalMessage()}
          <Circles
            height="80"
            width="80"
            color="#B3BDF1"
            ariaLabel="circles-loading"
            wrapperStyle={{ position: "absolute", left: "38%", top: "20%" }}
            wrapperClass=""
            visible={loading ? true : false}
          />
          {emailConfirmed ? (
            decide()
          ) : (
            <>
              <p>Enter the email you used for booking:</p>
              <input
                type="email"
                name="email"
                id="confirm-email"
                value={confirmationEmail}
                onChange={(e) => setConfirmationEmail(e.target.value)}
              />
              <div className="vertical-center">
                <button
                  type="submit"
                  className="submit-button"
                  onClick={(e) => confirmEmail(e)}
                >
                  Confirm Email
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Payment;
